import { CloseOutlined, MenuOutlined } from "@ant-design/icons";
import { Col, Row } from "antd";
import React, { useEffect } from "react";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import useDarkMode from "../../hooks/useDarkMode";
import useProDashboard from "../../hooks/useProDashboard";
import { AppboxLanguageSelect } from "../../components";
import AppSider from "./sider";
import ProAppSider from "./proSider";

const FullScreenMenu = ({ open, setOpen, darkMode, toggleDarkMode }) => {
    const navigate = useNavigate();
    const [proDashboard] = useProDashboard();

    const closeMenu = () => {
        setOpen(false);
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });
    };

    useEffect(() => {
        closeMenu();
    }, [navigate]);

    if (!open) return null;

    return (
        <div
            style={{
                height: "100vh",
                width: "100vw",
                position: "fixed",
                backgroundColor: darkMode ? "#141414" : "white",
                top: 0,
                left: 0,
                zIndex: 9999,
            }}>
            <Row style={{ height: "100px", padding: "0px 10px" }}>
                <Col span={16} style={{ paddingTop: "8px" }}>
                    <a href="/">
                        <img src="/logo_nero.png" alt="logo" height={"60px"} />
                    </a>
                </Col>

                <Col
                    span={8}
                    style={{
                        margin: 0,
                        display: "flex",
                        height: "100%",
                        flexDirection: "row-reverse",
                    }}>
                    <CloseOutlined
                        style={{ fontSize: "25px", padding: "10px" }}
                        onClick={() => closeMenu()}
                    />
                </Col>
            </Row>
            {/* <AppboxLanguageSelect />ß */}
            {proDashboard ? <ProAppSider showLanguage={true} /> : <AppSider showLanguage={true} />}

        </div>
    );
};

export default function MobileHeader({ }) {
    const [darkMode, toggleDarkMode] = useDarkMode();
    const [openMenu, setOpenMenu] = useState(false);

    return (
        <Row style={{ height: "100%" }}>
            <FullScreenMenu
                open={openMenu}
                setOpen={setOpenMenu}
                darkMode={darkMode}
                toggleDarkMode={toggleDarkMode}
            />
            <Col span={16} style={{ paddingTop: "1%" }}>
                <a href="/">
                    <img src="/logo_nero.png" alt="logo" height={"60px"} />
                </a>
            </Col>

            <Col
                span={8}
                style={{
                    margin: 0,
                    display: "flex",
                    height: "100%",
                    flexDirection: "row-reverse",
                }}>
                <MenuOutlined
                    style={{ fontSize: "25px", padding: "10px" }}
                    onClick={() => setOpenMenu(!openMenu)}
                />
            </Col>
        </Row>
    );
}
